import { PureComponent, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { capitalize } from 'lodash-es';
import Checkbox from 'components/Checkbox';
import Form from 'components/Form';
import Image from 'components/Image';
import Select from 'components/Select';
import Button from 'components/Button';
import {
  InputHasErrorIcon,
  InputHasPasswordToggleErrorIcon,
} from 'components/Input/InputVariants';

import { apiLogin } from 'constants/api';

import LoginHeader from './LoginHeader';
import { LOGIN_HEADER_PROPS, INITIAL_VALUES, LOGIN_OPTIONS } from './constants';
import cn from "classnames";

class LoginForm extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      type: 'partner',
      chooseLoginType: false,
      rememberMe: false,
    };

    this.emailFieldRef = React.createRef();
    this.passwordFieldRef = React.createRef();
  }


  handleResponse = ({ data }, toggleSubmitting) => {
    const { type, redirectUrl } = data;

    if (type !== 'both') {
      return window.location.replace(redirectUrl);
    }

    toggleSubmitting(false);
    this.setState({ chooseLoginType: true });
  };

  handleTypeSelection = ({ value }) => {
    this.setState({ type: value });
  };

  handleCheckboxClick = ({ value }) => {
    this.setState({ rememberMe: value });
  };

  handleAuthAs = (data) => apiLogin.authoriseAs(data, this.state.type);

  render() {
    const { chooseLoginType } = this.state;
    return (
      <Fragment>
        <LoginHeader {...LOGIN_HEADER_PROPS} />
        <Form
          className="login__form"
          initialValues={INITIAL_VALUES}
          onResponse={this.handleResponse}
          request={chooseLoginType ? this.handleAuthAs : apiLogin.authorise}
          autocomplete="off"
        >
          {({ submitting, onChange, errors, values }) => {
            const passwordToggleClasses = cn('btn input__password-switch', {
              'has-value': values.password,
            })

            return (
                <Fragment>
                  <div className="login__form-row _mb-20">
                    <InputHasErrorIcon
                        name="email"
                        className="login__input login__input_email"
                        placeholder="Email"
                        icon="email"
                        iconClassName="login__input-holder"
                        value={values.email.trim()}
                        onChange={(data) =>
                            onChange({ ...data, value: data.value.trim() })
                        }
                        error={errors.submitErrors || errors.email}
                        innerRef={this.emailFieldRef}
                    />
                  </div>
                  <div className="login__form-row _mb-20">
                    <InputHasPasswordToggleErrorIcon
                        name="password"
                        className="login__input login__input_password input_password"
                        value={values.password}
                        placeholder="Password"
                        icon="password"
                        iconClassName="login__input-holder"
                        buttonClassName={passwordToggleClasses}
                        onChange={onChange}
                        error={errors.password}
                        invalid={errors.submitErrors}
                        innerRef={this.passwordFieldRef}
                    />
                  </div>
                  {chooseLoginType ? (
                      <div className="login__form-row _mb-20">
                        <Select
                            options={LOGIN_OPTIONS}
                            value={this.state.type}
                            onChange={this.handleTypeSelection}
                        />
                      </div>
                  ) : null}
                  <div className="login__form-row login__form-row_flex _mb-20">
                    <Checkbox
                        name="rememberMe"
                        value={this.state.rememberMe}
                        onChange={this.handleCheckboxClick}
                    />
                    <Link to="/login/recovery" className="login__password-recovery">
                      Can't log in?
                    </Link>
                  </div>
                  <div className="login__form-row _mb-60">
                    <Button className="login__btn" submitting={submitting}>
                      Log In
                      {chooseLoginType && ` as ${capitalize(this.state.type)}`}
                    </Button>
                  </div>
                </Fragment>
            )
          }}
        </Form>

        <div className="login__subtitle-wrap">
          <div className="text login__subtitle login__subtitle_inner">
            Or continue with
          </div>
        </div>
        <div className="login__form-row login__form-row_flex login__form-row_hidden">
          <button className="btn login__btn-social">
            <Image className="login__btn-social-img" src="google-icon.svg" />
            <span className="login__btn-social-text">Google</span>
          </button>
          <button className="btn login__btn-social login__btn-social_facebook">
            <Image className="login__btn-social-img" src="facebook-icon.svg" />
            <span className="login__btn-social-text">Facebook</span>
          </button>
        </div>
      </Fragment>
    );
  }
}

export default LoginForm;
